// extracted by mini-css-extract-plugin
export default {"yellow_block_wrap":"styles_yellow_block_wrap__2C9uY","yellow_block_text_bold":"styles_yellow_block_text_bold__ZBNSl","buttons_wrap":"styles_buttons_wrap__yY-0F"};